module.exports = __webpack_public_path__ + "img/zwsj.cce9ca95.png";